<div class="modal-wrapper" *ngIf="showForm" [ngClass]="{ loaded: loaded }">
  <div class="wrapper">
    <div
      class="under-wrapper"
      sdClickOutside
      (clickOutside)="closeModal($event)"
      [ngClass]="{ loaded: loaded }"
      #parent
      [parentRef]="parent"
      role="dialog"
      aria-modal="true"
      aria-labelledby="gpsrPopupTitle"
    >
      <div class="navigation-bar">
        <button type="button" class="arrow-back gpsr-icon-button" (click)="closeModal($event)" aria-label="Wróć">
          <i class="ai ai-back" aria-hidden="true"></i>
        </button>
        <span class="heading5">Bezpieczeństwo produktu</span>
        <button type="button" class="img-wrapper cancel gpsr-icon-button" (click)="closeModal($event)" aria-label="Zamknij">
          <i class="ai ai-cancel" aria-hidden="true"></i>
        </button>
      </div>
      <div class="separator-gray full-height separator-one-half"></div>

      <button type="button" (click)="closeModal($event)" class="close-button gpsr-icon-button" aria-label="Zamknij">
        <i class="ai ai-cancel" aria-hidden="true"></i>
      </button>

      <div class="gpsr-scroll">
        <div id="gpsrPopupTitle" class="font-style-semi main-title separator1">Bezpieczeństwo produktu</div>

        <p class="color-body-text description-under-title font-style-light">
          Dane wymagane rozporządzeniem (UE) 2023/988 o ogólnym bezpieczeństwie produktów (GPSR).
        </p>

        <section class="gpsr-section" *ngIf="view?.manufacturer">
          <h3 class="gpsr-section__title font-style-semi">Producent</h3>
          <ng-container *ngTemplateOutlet="operatorFields; context: { $implicit: view.manufacturer }"></ng-container>
        </section>

        <section class="gpsr-section" *ngIf="view?.euResponsible">
          <h3 class="gpsr-section__title font-style-semi">Podmiot odpowiedzialny</h3>
          <ng-container *ngTemplateOutlet="operatorFields; context: { $implicit: view.euResponsible }"></ng-container>
        </section>
      </div>
    </div>
  </div>
</div>

<ng-template #operatorFields let-operator>
  <dl class="gpsr-data">
    <div class="gpsr-field" *ngIf="operator.name">
      <dt class="gpsr-field__label">Nazwa</dt>
      <dd class="font-style-semi">{{ operator.name }}</dd>
    </div>

    <div class="gpsr-field" *ngIf="postalAddress(operator)">
      <dt class="gpsr-field__label">Adres</dt>
      <dd>{{ postalAddress(operator) }}</dd>
    </div>

    <div class="gpsr-field" *ngIf="operator.email">
      <dt class="gpsr-field__label">E-mail</dt>
      <dd><a class="gpsr-link" [href]="'mailto:' + operator.email">{{ operator.email }}</a></dd>
    </div>

    <div class="gpsr-field" *ngIf="!operator.email && contactHref(operator)">
      <dt class="gpsr-field__label">Strona www</dt>
      <dd>
        <a class="gpsr-link" [href]="contactHref(operator)" target="_blank" rel="noopener noreferrer">{{ operator.contactUrl }}</a>
      </dd>
    </div>
  </dl>
</ng-template>
